import React from 'react'
import { t } from 'ttag'

import { useTitleChange } from '../../util/hooks'

const CostBenefitInstructions = () => {
  useTitleChange(t`The Cost of College`)

  return (
    <div className="container">
      <p className="instructions lastitem">
        {t`Choosing the right college can be a daunting task. For many, this
                    decision is made harder because it is their first time living away from home for an extended period of time. Some people can't wait
                    to get away, and others may be nervous about venturing too far away.`}
      </p>
      <p className="instructions">
        {t`To find the right school, there are many things to consider like the size of
                    the school, whether you want to be in an urban or rural environment, sports teams available and whether it is a
                    good fit academically.`}
      </p>
      <p className="instructions">
        {t`As you use the tool, remember that economics is an important part of
                    deciding which school to attend. As more and more students are graduating with a significant amount
                    of debt, it pays to take a few moments to look at how much the cost of a particular school will impact you
                    after graduation. It is also important to remember that this is only one measure of the benefit of
                    attending this school. Many schools offer intangible benefits - for example: a powerful and connected
                    alumni network or great job placement services that can help you land a higher paying job.
                    Use the information you obtain to help you evaluate all the factors so that you choose the
                    right school for you.`}{' '}
      </p>
      <br />
      <br />
      <p>
        <a href="/colleges/costbenefit/occupation" className="submit">
          {t`Get Started`}
        </a>
      </p>
    </div>
  )
}

export default CostBenefitInstructions
